import axios from "axios";

export async function createCode({ commit }, formData) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Creando codigos",
    },
    { root: true }
  );
  return new Promise((resolve, reject) => {
    axios
      .post("/pet-codes/file/", formData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function getPetsCode({ commit }) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Cargando codigos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .get("/pets-files/")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function getData4excel({ commit }) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Cargando datos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .get("/4-excel-data/")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function getStores({ commit }) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Cargando datos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .get("/stores/")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function saveStore({ commit }, formData) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Creando codigos",
    },
    { root: true }
  );
  return new Promise((resolve, reject) => {
    axios
      .post("/stores/", formData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function modifyStoreData ({ commit }, {formData, id}) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Modificando información'
  }, { root: true });
  return new Promise((resolve, reject) => {
    axios
      .patch(`/stores/${id}/`, formData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}